export default [
  {
    label: '計測日時 ',
    key: 'created_at',
    _style: 'min-width:120px',
    sorter: false,
  },
  {
    label: 'デバイス名',
    key: 'device_name',
    _style: 'min-width:200px',
    sorter: false,
  },
  {
    label: 'アスリートモード',
    key: 'athlete',
    _style: 'min-width:60px',
    sorter: false,
  },
  {
    label: '体重',
    key: 'weight',
    _style: 'min-width:100px',
    slot: true,
    sorter: false,
  },
  {
    label: 'BMI ',
    key: 'BMI',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
  {
    label: '体脂肪率',
    key: 'body_fat_rate',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
  {
    label: '除脂肪体重',
    key: 'lean_body_weight',
    _style: 'min-width:90px',
    sorter: false,
  },
  {
    label: '皮下脂肪',
    key: 'subcutaneous_fat',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
  {
    label: '内臓脂肪',
    key: 'visceral_fat',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
  {
    label: '体水分率',
    key: 'body_water_rate',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
  {
    label: '骨格筋',
    key: 'muscle_rate',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
  {
    label: '総筋肉量',
    key: 'muscle_mass',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
  {
    label: '骨量',
    key: 'bone_mass',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
  {
    label: 'タンパク質',
    key: 'protein',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
  {
    label: '基礎代謝',
    key: 'BMR',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
  {
    label: '体内年齢',
    key: 'metabolic_age',
    _style: 'min-width:90px',
    slot: true,
    sorter: false,
  },
]
